export enum WorkOrderDetailStatus {
  INCOMPLETE = 'INCOMPLETE',
  SKIPPED = 'SKIPPED',
  COMPLETE = 'COMPLETE',
  BACKORDERED = 'BACKORDERED'
}
